import AuthenticationContext from 'adal-angular'
import AdalConfig from '../config/AdalConfig'

// We use this to enable logging in the adal library. When you're building for production, you should know that it's best to disable the logging.
window.Logging.log = function (message) {
}
window.Logging.level = 2 // 0 = only error, 1 = up to warnings, 2 = up to info, 3 = up to verbose
var AuthContext = new AuthenticationContext(AdalConfig);
// Initialize the authentication
export default AuthContext;